module.exports = __webpack_public_path__ + "img/info_outlined.ad1759dd.svg";